module.exports = __webpack_public_path__ + "img/016.18450e7e.png";